import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { ChangePassword } from "./ui/molecules/ChangePassword";

export const Settings = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{ width: "100%", minWidth: { xs: "none", sm: "none", md: "1024px" } }}
    >
      <Typography sx={{ mb: "12px" }} variant="h5">
        {t("settings")}
      </Typography>
      <Box
        sx={{
          mr: "24px",
        }}
      >
        {" "}
        <ChangePassword />
      </Box>
    </Box>
  );
};
